import { render, staticRenderFns } from "./ActionExpectedForms.vue?vue&type=template&id=f45b4de6"
import script from "./ActionExpectedForms.vue?vue&type=script&lang=js"
export * from "./ActionExpectedForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports